<adaa-item-slider class="my-3" [showPerformance]="true" [scrollInput]="312" [arrowsInHeader]="true">
    <h5 title class="strategies-perf__title">
        {{ "dashboard.strategies_directions_performance" | translate }}
        <b>{{ periodLabel() }}</b>
    </h5>

    <div performance class="strategies-perf__mark">
        <img class="theme-light-only" src="assets/images/national-strategies/national-strategy_light.png" alt="" />
        <img class="theme-dark-only" src="assets/images/national-strategies/national-strategy_dark.png" alt="" />
    </div>

    @for (direction of directions(); track direction.id) {
        <adaa-national-strategies-perf-card [data]="direction" />
    }
</adaa-item-slider>
